import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import remove from "@beeldit/core/services/remove";
import { PayActionContext } from "./PayActionContext";
import store from "@beeldit/core/services/store";

function usePay(modelConfig: any) {
  const { elementId, setShowModal } = useContext(PayActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    store(modelConfig.endpoint + 'payments/1/confirm-payment', { external_id: elementId })
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default usePay;
